import { takeLatest, call, put, select } from 'redux-saga/effects';

import { home } from '@coconut/services/redux/navigation';
import { getUserId } from '@coconut/services/redux/profile';
import { fetchQuestionQuota } from '@coconut/services/redux/questionQuota';

import { types, actions } from '../redux/uploadImage';
import * as apis from '../apis/uploadImage';
import { getCapitalizedRegionLang } from '@coconut/utils/langParser';

function* uploadImageFlow(action) {
  const { file, desc, subjectId, lang } = action.payload;
  const studentId = yield select(getUserId);
  try {
    yield call(apis.postQuestion, {
      studentId,
      file,
      desc,
      subjectId,
      lang: getCapitalizedRegionLang(lang),
    });

    yield put(actions.uploadImageSuccess());
    yield put(fetchQuestionQuota(studentId));
    yield put(home());
  } catch (err) {
    yield put(actions.uploadImageFailed());
  }
}

export default function* () {
  yield takeLatest(types.UPLOAD_IMAGE_REQUEST, uploadImageFlow);
}



// WEBPACK FOOTER //
// ./src/scenes/UploadImage/services/sagas/uploadImage.js